import React, { useState } from 'react'
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules'
import { Swiper, SwiperProps } from 'swiper/react'
import { AreaSlide, SwiperSlide } from './styles'
import { ProductVerticalWithAnalytics } from 'src/components/productVertical'
import {
  mapLinxProductApiToProductVerticalItem,
  mapProductToAnalyticsProduct,
} from 'src/components/productVertical/utils'
import { ProductApi } from 'src/types'

interface ProductsPickYouSlideProps {
  maxWidth?: number
  products: ProductApi[]
}

export const ProductsPickUpSlide: React.FC<ProductsPickYouSlideProps> = ({
  maxWidth,
  products,
}) => {
  const [updateSwiper] = useState<any>(null)

  const fractionParams: SwiperProps = {
    modules: [Navigation, Pagination, Scrollbar, Autoplay],
    pagination: { type: 'bullets', clickable: true },
    navigation: false,
    zoom: { maxRatio: 1.6 },
    onSwiper: updateSwiper,
    speed: 800,
    slidesPerView: 1.25,
    spaceBetween: 10,
    autoplay: { delay: 4000 },
    breakpoints: {
      810: {
        spaceBetween: 12,
      },
      1165: {
        slidesPerView: 'auto',
        spaceBetween: 16,
      },
      1300: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    },
    style: { padding: '1.2rem 1rem 1.65rem 0.35rem' },
  }

  return (
    <AreaSlide maxW={maxWidth}>
      <Swiper {...fractionParams}>
        {products.map((product, index) => (
          <SwiperSlide key={index}>
            <ProductVerticalWithAnalytics
              analyticsProduct={mapProductToAnalyticsProduct(product)}
              border="1px solid #E3E3E8"
              product={mapLinxProductApiToProductVerticalItem(product)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </AreaSlide>
  )
}
